import {InjectionToken} from '@angular/core';

export const FIREBASE_FUNCTIONS_URL = new InjectionToken<string>('API url to firebase cloud functions');
